import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddShoppingCartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_shopping_cart"}/>
}
